import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createCompany } from '../../store/companies';

function CreateCompany() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(state => state.session.user);
  const [companyName, setCompanyName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);

  if (!user || !user.is_admin) {
    history.push('/');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    if (!companyName.trim()) {
      setErrors(['Company name is required']);
      return;
    }

    try {
      setIsSubmitting(true);
      const newCompany = await dispatch(createCompany({ company_name: companyName.trim() }));
      history.push('/companies');
    } catch (error) {
      console.error('Error creating company:', error);
      setErrors(error.toString().split(','));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-5 min-h-[calc(100vh-100px)] flex flex-col">
      <div className="max-w-3xl mx-auto w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-6xl font-bold text-blue-600 mb-6">Create New Company</h2>

        {errors.length > 0 && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6" role="alert">
            <p className="font-bold text-2xl">Please fix the following errors:</p>
            <ul className="list-disc pl-10 mt-2">
              {errors.map((error, idx) => (
                <li key={idx} className="text-xl">{error}</li>
              ))}
            </ul>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="companyName" className="block text-2xl font-medium text-gray-700 mb-2">
              Company Name
            </label>
            <input
              id="companyName"
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className="w-full px-4 py-3 text-2xl border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter company name"
              required
            />
          </div>

          <div className="flex gap-4 pt-4">
            <button
              type="button"
              onClick={() => history.push('/companies')}
              className="px-6 py-3 text-2xl text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`px-6 py-3 text-2xl text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
              }`}
            >
              {isSubmitting ? 'Creating...' : 'Create Company'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateCompany;
